import type React from "react";
import styles from "./LayoutMobile.module.scss";
import backgroundVideo from "../../assets/video/background_stripes.mp4";
import backgroundPoster from "../../assets/pictures/background-poster.png";
import { useTranslation } from "react-i18next";
import laptopImg from "../../assets/pictures/laptop.png";

const LayoutMobile: React.FC = () => {
	const { t } = useTranslation("modals");
	return (
		<div className={styles.containerLayoutMobile}>
			<video
				autoPlay={true}
				loop={true}
				muted={true}
				preload="auto"
				playsInline
				className={styles.video}
				poster={backgroundPoster}
			>
				<source src={backgroundVideo} type="video/mp4" />
			</video>
			<div className={styles.content}>
				<img src={laptopImg} alt="laptop" className={styles.laptop} />
				<h2 className={styles.title}>{t("mobile_warning_title")}</h2>
				<p className={styles.desc}>{t("mobile_warning_text")}</p>
			</div>
		</div>
	);
};

export default LayoutMobile;
